import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-bootstrap';
import Select from 'react-select';

import { GET_L4_CATEGORIES_FOR_SELECTED_VENDOR_AND_BRAND } from 'lib/networking/endpoints';
import useGet from 'lib/hooks/useGet';

function L4CategoryDropdown({
  selectedL4Category,
  setSelectedL4Category,
  globalVendorId = null,
  brandId = null,
  suggestedAction = null,
  isDisabled = false,
  placeholder = 'Select L4 Category',
  label = 'L4 Category',
  showLabel = true,
  isClearable = true,
  onCategoriesLoaded,
}) {
  const {
    data: { data: l4Categories = [] } = {},
    loading: loadingL4Categories,
    refetch: refetchL4Categories,
  } = useGet(GET_L4_CATEGORIES_FOR_SELECTED_VENDOR_AND_BRAND, {
    global_vendor_id: globalVendorId,
    brand_id: brandId,
    suggested_action: suggestedAction,
  });

  // Refetch when filter dependencies change
  useEffect(() => {
    refetchL4Categories();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalVendorId, brandId, suggestedAction]);

  // Notify parent when categories are loaded
  useEffect(() => {
    if (onCategoriesLoaded && l4Categories?.length) {
      onCategoriesLoaded(l4Categories);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [l4Categories]);

  const options = l4Categories?.map(l4Category => ({
    value: l4Category.id,
    label: l4Category.name,
  }));

  return (
    <Form.Group>
      {showLabel && <Form.Label>{label}</Form.Label>}
      <Select
        value={selectedL4Category}
        options={options}
        onChange={e => setSelectedL4Category(e)}
        placeholder={placeholder}
        isLoading={loadingL4Categories}
        isClearable={isClearable}
        isDisabled={isDisabled}
        isSearchable
      />
    </Form.Group>
  );
}

L4CategoryDropdown.propTypes = {
  selectedL4Category: PropTypes.object,
  setSelectedL4Category: PropTypes.func.isRequired,
  globalVendorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  brandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  suggestedAction: PropTypes.string,
  isDisabled: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  showLabel: PropTypes.bool,
  isClearable: PropTypes.bool,
  onCategoriesLoaded: PropTypes.func,
};

export default L4CategoryDropdown;
